import React, { PropsWithChildren } from 'react';
import {
    StyledContent,
    StyledMenu,
    StyledMenuContainerContent,
    StyledMenuList,
    StyledMenuItem,
} from './styled';
import { Container } from '../container/container.component';

type Props = {
    menu: JSX.Element[];
};

/**
 * Used to render a menu layout with left side navigation and right side content
 */
export const MenuModuleContainer = ({ menu, children }: PropsWithChildren<Props>) => {
    return (
        <Container hasGutter spacingTop='default' spacingBottom='default'>
            <StyledMenuContainerContent>
                <StyledMenu>
                    <StyledMenuList>
                        {menu.map((menuItem, i) => (
                            <StyledMenuItem key={i}>{menuItem}</StyledMenuItem>
                        ))}
                    </StyledMenuList>
                </StyledMenu>
                <StyledContent>{children}</StyledContent>
            </StyledMenuContainerContent>
        </Container>
    );
};
